// Dashboard.jsx

import React, { useState } from 'react';
import './Dashboard.scss';
import GeneralSettings from './components/general-settings/GeneralSettings';
import AdvancedSettings from './components/advanced-settings/AdvancedSettings';
import BannerSettings from './components/banner-settings/BannerSettings';
import AnnouncementsSettings from './components/announcements-settings/AnnouncementsSettings';

const Dashboard = () => {
  const [activeOption, setActiveOption] = useState('');

  const handleOptionClick = (option) => {
    setActiveOption(option);
  };

  const renderOptionContent = () => {
    switch (activeOption) {
      case 'general':
        return <GeneralSettings />;
      case 'advanced':
        return <AdvancedSettings />;
      case 'banner':
        return <BannerSettings />;
      case 'announcements':
        return <AnnouncementsSettings />;
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <div className="dashboard-container">
      <div className="top-bar">
        <div className="title">Hero's Toolbox</div>
      </div>
      <div className="content-wrapper">
        <div className="sidebar">
          <div
            className={`option ${activeOption === 'general' ? 'active' : ''}`}
            onClick={() => handleOptionClick('general')}
          >
            Algemene instellingen
          </div>
          <div
            className={`option ${activeOption === 'advanced' ? 'active' : ''}`}
            onClick={() => handleOptionClick('advanced')}
          >
            Geavanceerde Instellingen
          </div>
          <div
            className={`option ${activeOption === 'banner' ? 'active' : ''}`}
            onClick={() => handleOptionClick('banner')}
          >
            Banner instellingen
          </div>
          <div
            className={`option ${activeOption === 'announcements' ? 'active' : ''}`}
            onClick={() => handleOptionClick('announcements')}
          >
            Aankondiging instellingen
          </div>
        </div>
        <div className="content-container">
          {renderOptionContent()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
